import router from '../router'

export function encodeParams (params) {
  let urlParams = ''
  let valToStr = (val) => (typeof val === 'object') ? JSON.stringify(val) : val
  if (Object.keys(params).length) {
    urlParams += '?' + Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(btoa(valToStr(params[key])))
    }).join('&')
  }
  return urlParams
}

export function updateUrlFiltersParam (filters) {
  // console.log('filters11111', filters);

  // if (filters.find(filter => filter.type === 'colour')) {
  //   console.log('11111122222222222222',JSON.stringify(filters));

  //   filters = JSON.parse(JSON.stringify(filters)) // Update to be a deep copy

  //   let colourFilter = filters.find(filter => filter.type === 'colour')
  //   console.log('colourFilter33333', colourFilter);

  //   colourFilter.values = colourFilter.values.map(col => col.name)

  //   console.log('colourFilter44444', colourFilter);



  // }
  updateUrlParam('filters', filters)
}

/**
 * Updates a parameter in the current url and updates the router's currentRoute.query property too.
 * @param key       name of the query parameter
 * @param value     the value of the query parameter (if it's null, undefined or an empty array the parameter is removed from the query string instead of added
 * @param newTitle  you can update the browser title if desired, ignore this parameter to leave unchanged
 * @param pushState  if true, it will replace the state instead of pushing to it
 */
export function updateUrlParam (key, value, newTitle, pushState) {
  let newRoute = `${router.currentRoute.path}`
  if (value === null || value === undefined || !value.length) {
    // if the current uri has this parameter, delete it
    if (!(key in router.currentRoute.query)) return
    delete router.currentRoute.query[key] // Want to edit the current route at the same time otherwise it won't be updated
    newRoute += encodeParams(router.currentRoute.query)
  } else {
    router.currentRoute.query[key] = value // Want to edit the current route at the same time otherwise it won't be updated
    newRoute += encodeParams(router.currentRoute.query)
  }

  // Push to browser history and don't touch vue-router apart from editing query above
  if (pushState) {
    history.pushState('', newTitle || document.title, newRoute)
  } else {
    history.replaceState('', newTitle || document.title, newRoute)
  }
}
